import { twMerge } from "tailwind-merge";

const Loader = ({ size = "size-16" }) => {
  return (
    <div className="flex h-screen items-center justify-center bg-background dark:bg-white">
      <div
        className={twMerge(
          "animate-spin rounded-full border-4 border-solid border-primary border-t-transparent",
          size,
        )}
      ></div>
    </div>
  );
};

export default Loader;